import { Stack, Typography } from "@mui/material";
import { InputWithQuery } from "../ui/InputWithQuery";
import { DropdownWithSearch } from "../ui/dropdown";
import { CustomCheckbox, CustomTextButton } from "../ui";
import { Dropdown } from "../ui/dropdown/Dropdown";
import { useStateWithSearchParams } from "../../hooks";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../types/enums";

const ratingList = [
  "1 – Unsuitable for use",
  "2 – Needs significant improvement",
  "3 – Acceptable but unremarkable",
  "4 – Meets expectations",
  "5 – Exceeds expectations",
];

const options = {
  "Newest First": "created_at-desc",
  "Oldest First": "created_at-asc",
  "Highest Rated Reviews First": "average_score-desc",
  "Lowest Rated Reviews First": "average_score-asc",
} as const;

type Label = keyof typeof options;
type Value = (typeof options)[Label];

const reverseOptions: Record<Value, Label> = Object.fromEntries(
  Object.entries(options).map(([label, value]) => [value, label]),
) as Record<Value, Label>;

type SearchParams = {
  rating?: string;
  sort?: string;
  search?: string;
  has_files?: string;
};

export const FiltersBlock = () => {
  const navigate = useNavigate();
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      rating: undefined,
      sort: undefined,
      search: undefined,
      has_files: undefined,
    },
  );

  const resetFiltersHandler = () => {
    navigate(AppRoutes.REVIEWS);
  };

  const isFilters = Object.values(searchDict).some((el) => el);

  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack flexDirection="row" gap="8px" alignItems="center">
        <InputWithQuery maxWidth="350px" />
        <Dropdown
          maxHeight="fit-content"
          maxItemsWidth="280px"
          selectedItem={{
            value: searchDict.sort
              ? reverseOptions[searchDict.sort as Value]
              : "Newest First",
          }}
          onChange={(item) =>
            setSearchValue("sort", options[item.value as keyof typeof options])
          }
          label=""
          placeholder=""
          items={Object.keys(options).map((value) => ({
            value,
          }))}
        />
        <DropdownWithSearch
          placeholder="Rating"
          query="rating"
          items={["1", "2", "3", "4", "5"]}
          withSearch={false}
          withReset={false}
          renderItem={(item) => `${ratingList[Number(item) - 1]}`}
        />
        <Stack
          onClick={() =>
            setSearchValue(
              "has_files",
              !searchDict.has_files ? "true" : undefined,
            )
          }
          component="span"
          sx={{
            flexDirection: "row",
            gap: "4px",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <CustomCheckbox checked={!!searchDict.has_files} />
          <Typography
            variant="body1"
            color="#1F2932"
            component="span"
            lineHeight="14px"
            noWrap={true}
          >
            Attached Files
          </Typography>
        </Stack>
      </Stack>

      {isFilters && (
        <CustomTextButton onClick={resetFiltersHandler}>
          Reset All
        </CustomTextButton>
      )}
    </Stack>
  );
};
